<template>
  <div class="page-content">
    <div class="">
      <div class="panel">
        <div>
          <div style="font-weight: bold; text-align: center; color: red">
            <template v-if="$utils.toTime(config.guidanceStartTime) > nowDate"
              >还未到开题报告提交时间</template
            >
            <template v-if="$utils.toTime(config.guidanceEndTime) < nowDate"
              >开题报告提交时间已经截止</template
            >
          </div>

          <template
            v-if="
              config.notice &&
              (!$utils.toTime(config.noticeEndDate) ||
                $utils.toTime(config.noticeEndDate) > nowDate)
            "
          >
            <div>
              <span class="red">考生论文须知：</span>
              <div
                id="t_notice_content"
                v-html="config.notice"
                class="t_notice_content"
              ></div>
            </div>
            <input type="hidden" id="boo" value="true" />
          </template>
        </div>

        <template
          v-if="
            !thesisProposal &&
            $utils.toTime(config.guidanceStartTime) < nowDate &&
            $utils.toTime(config.guidanceEndTime) > nowDate
          "
        >
          <template v-if="config.paySwitch == 1 && bm.isPaid == 0">
            <div style="font-weight: bold; text-align: center; color: red">
              需要先缴费才能提交开题报告!
            </div>
            <div style="text-align: center; padding: 20px">
              <el-button
                type="primary"
                size="mini"
                @click="pay(bm.thesisBatchId, bm.courseId, 'BYLW2')"
                >点击缴费</el-button
              >
            </div>
          </template>
          <template
            v-if="
              (config.paySwitch == 1 && bm.isPaid == 1) || config.paySwitch == 0
            "
          >
            <el-form
              id="form_thesisProposal_add"
              :model="form"
              :rules="rules"
              ref="ruleForm"
              :inline-message="true"
            >
              <input type="hidden" name="wx_id" value="" />
              <table
                width="100%"
                cellpadding="5"
                border="0"
                class="tm_table_form"
              >
                <tbody>
                  <template v-if="configs">
                    <tr>
                      <th style="min-width: 200px">批次 :</th>
                      <td>
                        <el-select
                          v-model="defaultThesisBatchId"
                          @change="getInfo"
                        >
                          <el-option
                            v-for="item in configs"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </td>
                    </tr>
                  </template>
                  <tr>
                    <th>开题报告提交时间 :</th>
                    <td>
                      <el-form-item prop="direction">
                       {{ config.guidanceStartTime }} 至 {{ config.guidanceEndTime }}
                      </el-form-item>
                    </td>
                  </tr>
                  <tr v-if="bm && bm.teacherName && bm.teacherPhone">
                    <th>指导老师 :</th>
                    <td style="color: red;">
                      {{ bm.teacherName }}({{ bm.teacherPhone }}) 论文相关问题，请与老师联系。
                    </td>
                  </tr>
                  <tr>
                    <th><span class="xw_required">*</span>论文题目 :</th>
                    <td>
                      <el-form-item prop="title">
                        <div v-show="sTopic == 1">
                          <el-input
                            v-model="form.title"
                            placeholder=""
                            style="width: calc(100% - 320px)"
                            maxlength="1000"
                          ></el-input>
                          <el-button
                            type="primary"
                            size="mini"
                            class="ml"
                            @click="checkTitleExists()"
                            >校验题目是否重复</el-button
                          >
                        </div>
                        <div v-show="sTopic == 2">
                          <el-input
                            v-model="form.title"
                            placeholder=""
                            style="width: calc(100% - 140px)"
                            maxlength="1000"
                            disabled
                          ></el-input>
                          <el-button
                            type="primary"
                            size="mini"
                            class="ml"
                            @click="checkTitleExists()"
                            >校验题目是否重复</el-button
                          >
                        </div>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <th><span class="xw_required">*</span>英文题目 :</th>
                    <td>
                      <el-form-item prop="enName">
                        <el-input
                          v-model="form.enName"
                          placeholder=""
                          style="width: 100%"
                          maxlength="500"
                        ></el-input>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <th><span class="xw_required">*</span>论文方向 :</th>
                    <td>
                      <el-form-item prop="direction">
                        <el-input
                          v-model="form.direction"
                          placeholder=""
                          style="width: 100%"
                          maxlength="50"
                        ></el-input>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <th><span class="xw_required">*</span>论文关键词 :</th>
                    <td>
                      <el-form-item prop="keyword">
                        <el-input
                          v-model="form.keyword"
                          placeholder=""
                          style="width: 100%"
                          maxlength="50"
                        ></el-input>
                      </el-form-item>
                    </td>
                  </tr>
                

                  <tr v-if="this.topicList.length">
                    <th style="width: 200px">
                      <span class="xw_required">*</span>选题类型 :
                    </th>
                    <td>
                      <div>
                        <el-select v-model="sTopic" @change="sTopicChange">
                          <el-option label="自拟题目" value="1"> </el-option>
                          <el-option label="选题" value="2"> </el-option>
                        </el-select>
                        <el-select
                          style="margin-left: 10px"
                          v-show="sTopic == 2"
                          v-model="form.questionId"
                          placeholder="请选择"
                          filterable
                          @change="xqChange"
                        >
                          <el-option
                            v-for="item in topicList"
                            :key="item.tqId"
                            :label="item.tqContent"
                            :value="item.tqId"
                          >
                          </el-option>
                        </el-select>
                      </div>
                      <div>
                        <span class="red"> 选题类型提交后不可更改</span>
                      </div>
                    </td>
                  </tr>

                
                  <template v-if="false">
                    <tr>
                      <th>
                        <span class="xw_required">*</span>
                        一、论文（设计）选题的依据（选题的目的和意义、该选题在国内外的研究现状及发展趋势、主要参考文献等）
                      </th>
                      <td>
                        <el-form-item prop="outline1">
                          <el-input
                            type="textarea"
                            :rows="4"
                            placeholder=""
                            v-model="form.outline1"
                          >
                          </el-input>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <span class="xw_required">*</span
                        >二、论文（设计）的主要研究内容及预期目标
                      </th>
                      <td>
                        <el-form-item prop="outline2">
                          <el-input
                            type="textarea"
                            :rows="4"
                            placeholder=""
                            v-model="form.outline2"
                          >
                          </el-input>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <span class="xw_required">*</span
                        >三、论文（设计）的主要研究方案（拟采用的研究方法、准备工作情况及主要措施）
                      </th>
                      <td>
                        <el-form-item prop="outline3">
                          <el-input
                            type="textarea"
                            :rows="4"
                            placeholder=""
                            v-model="form.outline3"
                          >
                          </el-input>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <span class="xw_required">*</span
                        >四、论文（设计）研究工作进展安排
                      </th>
                      <td>
                        <el-form-item prop="outline4">
                          <el-input
                            type="textarea"
                            :rows="4"
                            placeholder=""
                            v-model="form.outline4"
                          >
                          </el-input>
                        </el-form-item>
                      </td>
                    </tr>
                  </template>
                  <!-- <tr>
                    <th>
                      <span class="xw_required">*</span>
                      承诺书签名
                    </th>
                    <td>
                      <div class="pledge-sign-box">
                        <el-button
                          type="primary"
                          plain
                          size="mini"
                          @click="openPledgeDialog()"
                        >
                          点击扫码签名
                        </el-button>
                        <div
                          v-if="pledgeSign"
                          class="pledge-sign-preview"
                        >
                          <img :src="pledgeSign" alt="承诺书签名预览" />
                          <el-button
                            type="text"
                            size="mini"
                            @click="clearPledgeSign"
                          >
                            重新签名
                          </el-button>
                        </div>
                        <span v-else class="pledge-sign-placeholder">
                          尚未签名，请先扫码签名
                        </span>
                      </div>
                    </td>
                  </tr> -->
                  
                  <!-- <tr>
                    <th></th>
                    <td>
                      <span class="red"
                        >请关注主考学校论文考核及论文质量要求。一般不少于15篇（设计类和软件类不少于10篇）。</span
                      >
                    </td>
                  </tr> -->
                </tbody>

                <tfoot>
                  <tr>
                    <th></th>
                    <td>
                      <div style="font-weight: bold; color: red; margin-bottom: 4px;">注意：提交论文题目前请与论文指导老师确认好题目，提交后论文题目将无法修改。</div>
                      <!-- <el-button
                        type="primary"
                        size="mini"
                        @click="handleSubmitClick"
                        >提交</el-button
                      > -->
                      <el-button
                        type="primary"
                        size="mini"
                        @click="handleSubmitClick"
                        >提交</el-button
                      >
                      <el-button size="mini" @click="$router.go(-1)"
                        >取消</el-button
                      >
                    </td>
                  </tr>
                </tfoot>
              </table>
            </el-form>
          </template>
        </template>
      </div>
    </div>
    <RegisteredPayDialog
      ref="RegisteredPayDialog"
      @refresh="getInfo"
    ></RegisteredPayDialog>
    <PledgeDialog
      ref="pledgeDialog"
      @confirm="onPledgeConfirm"
      @sign-selected="onSignSelected"
    />
    <Notice ref="Notice" />
  </div>
</template>

<script>
export default {
  name: "",
  components: {
    Notice: () => import("../Notice.vue"),
    RegisteredPayDialog: () => import("./RegisteredPayDialog.vue"),
    PledgeDialog: () => import("./PledgeDialog.vue"),
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (this.sTopic == "1") {
        //自拟
        if (this.form.title) {
          callback();
        } else {
          callback(new Error("请输入题目"));
        }
      } else if (this.sTopic == "2") {
        //选题
        if (this.form.questionId) {
          if (this.form.title) {
            callback();
          } else {
            callback(new Error("请输入题目"));
          }
        } else {
          callback(new Error("请选择题目"));
        }
      }
    };
    return {
      configs: [],
      info: {},
      defaultThesisBatchId: "",
      config: {},
      thesisProposal: null,
      thesis: null,
      db: null,
      logs: [],
      bm: null,
      curTime: "",
      nowDate: new Date().getTime(),
      form: {
        direction:''
      },
      pledgeSign: "",
      sTopic: "1",
      topicList: [],
      rules: {
        direction: [
          { required: true, message: "填写论文方向", trigger: "blur" },
        ],
        enName: [
          { required: true, message: "填写英文题目", trigger: "blur" },
        ],
        keyword: [
          { required: true, message: "填写论文关键词", trigger: "blur" },
        ],
        title: [{ validator: validatePass, trigger: ["blur", "change"] }],
        // title: [{ required: true, message: "请输入题目", trigger: "blur" }],
        outline1: [
          { required: true, message: "填写本题的根据", trigger: "blur" },
          { min: 100, message: "最少100个字符", trigger: "blur" },
        ],
        outline2: [
          { required: true, message: "填写本题的主要内容", trigger: "blur" },
          { min: 100, message: "最少100个字符", trigger: "blur" },
        ],
        outline3: [
          {
            required: true,
            message: "填写完成期限和采取主要措施",
            trigger: "blur",
          },
          { min: 100, message: "最少100个字符", trigger: "blur" },
        ],
        outline4: [
          { required: true, message: "填写主要参考文献书目", trigger: "blur" },
          { min: 100, message: "最少100个字符", trigger: "blur" },
        ],
      },
      isDisTitle: false,
      curT: null,
    };
  },
  created() {
    if (this.$route.query.thesisBatchId)
      this.defaultThesisBatchId = +this.$route.query.thesisBatchId;
    this.getInfo();
    this.curT = setInterval(() => {
      this.$http.post_s("/student/thesis2/getCurTime");
    }, 1000 * 60);
  },
  destroyed() {
    if (this.curT) {
      clearInterval(this.curT);
      this.curT = null;
    }
  },
  methods: {
    getTopicList() {
      let courseId = null;
      if (this.bm && this.bm.courseId) {
        courseId = this.bm.courseId;
      } else if (this.thesisProposal && this.thesisProposal.courseId) {
        courseId = this.thesisProposal.courseId;
      }

      this.$http
        .post("/student/thesisProposal2/thesisProposalTopic", {
          thesisBatchId: this.defaultThesisBatchId,
          courseId: courseId,
          questionUse: "no",
        })
        .then((res) => {
          if (res) {
            this.topicList = res || [];
          }
        });
    },
    getInfo() {
      this.$http
        .post("/student/thesis2/myThesis", {
          thesisBatchId: this.defaultThesisBatchId,
        })
        .then((res) => {
          this.config = res.config;
          this.configs = res.configs;
          this.info = res;
          if (!this.defaultThesisBatchId)
            this.defaultThesisBatchId = res.defaultThesisBatchId;
          this.thesisProposal = res.thesisProposal;
          this.thesis = res.thesis;
          this.db = res.db;
          this.bm = res.bm;
          this.logs = res.logs;
          this.curTime = res.curTime;
          this.reportLogId = res.reportLogId;
          this.form.direction = res.spec_code+'-'+res.spec_name;
          this.getTopicList();
          if (res.router == "addThesisProposal") {
            // this.$router.push({
            //   path: "/main/addThesisProposal",
            //   query: { thesisBatchId: this.defaultThesisBatchId },
            // });
            this.gonggao(res.config.notice);
          } else if (res.router == "myThesisProposal") {
            this.$router.push({
              path: "/main/myThesisProposal",
              query: { thesisBatchId: this.defaultThesisBatchId },
            });
          } else if (res.router == "myThesis") {
            this.$router.push({
              path: "/main/thesis2",
              query: { thesisBatchId: this.defaultThesisBatchId },
            });
          } 
        });
    },
    gonggao(n) {
      if (
        this.config.notice &&
        (!this.$utils.toTime(this.config.noticeEndDate) ||
          this.$utils.toTime(this.config.noticeEndDate) > this.nowDate)
      ) {
        const u_id = this.$store.state.user.userId + "2";
        if (!sessionStorage.getItem(u_id) && n) {
          this.$refs.Notice.open(n, () => {
            sessionStorage.setItem(u_id, "1");
          });
        }
      }
    },
    handleSubmitClick() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // 先确保有签名，没有的话先去签名
          // if (!this.pledgeSign && this.$refs.pledgeDialog) {
          //   this.openPledgeDialog(true);
          //   return;
          // }
          this.$confirm("提交论文题目前请与论文指导老师确认好题目，提交后论文题目将无法修改。", "提示", {
            confirmButtonText: "继续",
            cancelButtonText: "取消",
            type: "warning",
          }).then((r) => {
            this.submitThesisProposal();
          })
        }
      });
    },
    openPledgeDialog(autoSubmit = false) {
      const payload = this.buildPledgePayload();
      if (this.pledgeSign) {
        payload.signImg = this.pledgeSign;
      }
      if (this.$refs.pledgeDialog) {
        this.$refs.pledgeDialog.open(payload, () => {
          if (autoSubmit) {
            this.submitThesisProposal({ skipValidate: true });
          }
        });
      }
    },
    buildPledgePayload() {
      const userInfo = this.$store.state.user || {};
      const bmInfo = this.bm || {};
      const majorFromInfo =
        this.info && (this.info.spec_code || this.info.spec_name)
          ? `${this.info.spec_code ? this.info.spec_code + "-" : ""}${
              this.info.spec_name || ""
            }`
          : "";
      return {
        cnTitle: this.form.title,
        enTitle: this.form.enName,
        stuName:
          userInfo.realname ||
          userInfo.realName ||
          userInfo.name ||
          userInfo.username ||
          userInfo.uname ||
          "",
        stuNo:
          bmInfo.stuNo ||
          bmInfo.stu_num ||
          bmInfo.stuNum ||
          userInfo.studentNo ||
          userInfo.username ||
          "",
        admissionNo: bmInfo.ticketNo || bmInfo.examNo || "",
        major: this.form.direction || majorFromInfo,
        className: bmInfo.className || bmInfo.clazzName || "",
        thesisBatchId: this.defaultThesisBatchId || "",
        date: new Date(),
      };
    },
    onSignSelected(sign) {
      this.pledgeSign = sign || "";
    },
    onPledgeConfirm(pledgeData) {
      this.pledgeSign = pledgeData && pledgeData.signImg
        ? pledgeData.signImg
        : this.pledgeSign;
    },
    clearPledgeSign() {
      this.pledgeSign = "";
    },
    submitThesisProposal(opts = {}) {
      const _t = this;
      const doSubmit = () => {
        const params = {
          ..._t.form,
          thesisBatchId: _t.defaultThesisBatchId,
        };
        if (this.pledgeSign) {
          params.signImg = this.pledgeSign;
        }
        if (this.sTopic == "1") {
          params.questionId = "";
        }
        _t.$http.post("/student/thesisProposal2/save", params).then((res) => {
          if (res) {
            this.$message({
              showClose: true,
              message: "操作成功。",
              type: "success",
            });
            _t.getInfo();
          }
        });
      };
      if (opts.skipValidate) {
        doSubmit();
        return;
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          doSubmit();
        } else {
          return false;
        }
      });
    },
    pay(thesisBatchId, courseId, bm_type) {
      const _t = this;
      // _t.axios
      //   .get(
      //     "/user/course/toPay?tid=" +
      //       thesisBatchId +
      //       "&courseId=" +
      //       courseId +
      //       "&bm_type=" +
      //       bm_type
      //   )
      //   .then((res) => {
      //     if (res) {
      //       _t.$refs.RegisteredPayDialog.open(JSON.stringify(res));
      //     }
      //   });
        this.$http
        .post("/student/thesis2/createOrder", {type:'bm',id:this.bm.id})
        .then((res) => {
          if (res) {
            _t.$refs.RegisteredPayDialog.open(res);
          }
        });
    },
    sTopicChange(e) {
      this.$set(this.form, "questionId", undefined);
      this.$set(this.form, "title", "");
      this.isDisTitle = false;
      this.$refs.ruleForm.validateField("title");
    },
    xqChange(e) {
      if (e) {
        const item = this.topicList.find((v) => v.tqId == e);
        this.$set(this.form, "title", item.tqContent);
        this.isDisTitle = item.tqContent.indexOf("XX") == -1;
      } else {
        this.isDisTitle = false;
        this.$set(this.form, "title", "");
      }
    },
    checkTitleExists() {
      if (!this.form.title) {
        this.$message({
          showClose: true,
          message: "请输入题目！",
          type: "error",
        });
        return;
      }
      const params = {
        ...this.form,
        title: this.form.title.trim()
      };
      this.$http
        .post("/student/thesisProposal2/checkTitleExists", params)
        .then((res) => {
          if (!res) {
            this.$message({
              showClose: true,
              message: "当前开题报告题目未重复。",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: "当前开题报告题目重复，请更换题目！",
              type: "error",
            });
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.xw_required {
  color: #f00;
}
#form_thesisProposal_add {
  .el-form-item {
    margin-bottom: 0;
  }
  &::v-deep .el-form-item__label {
    background: #f5f5f5;
  }
}
.ml {
  margin-left: 10px;
}
.pledge-sign-box {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.pledge-sign-preview {
  display: flex;
  align-items: center;
  gap: 8px;
  img {
    height: 44px;
    border: 1px solid #e5e5e5;
    padding: 4px;
    background: #fff;
  }
}
.pledge-sign-placeholder {
  color: #999;
}
</style>
